export const DeliveryIcon = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 14.8464C18.2508 15.3899 19 16.0819 19 16.8355C19 18.5832 14.9706 20 10 20C5.02944 20 1 18.5832 1 16.8355C1 16.0819 1.7492 15.3899 3 14.8464" stroke="" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <circle cx="10" cy="7" r="2" stroke="" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></circle>
            <path d="M4 7.51853C4 -1.17288 16 -1.17281 16 7.51853C16 10.8884 13.7726 13.6717 12.0322 15.3322C10.8758 16.4353 9.12452 16.4354 7.96814 15.3322C6.22754 13.6718 4 10.8885 4 7.51853Z" stroke="" strokeWidth="2"></path>
        </svg>
    );
}